import type { ReactNode } from "react";

import { FaGoogle, FaLinkedin, FaMicrosoft } from "react-icons/fa";
import { LuAtSign, LuFingerprint } from "react-icons/lu";
import { SiApple } from "react-icons/si";

import { DefaultConnectionIcon } from "@/assets/icons";

const ICON_MAP: Record<string, ReactNode> = {
  "google-oauth2": <FaGoogle size={18} />,
  apple: <SiApple size={18} />,
  windowslive: <FaMicrosoft size={18} />,
  linkedin: <FaLinkedin size={18} />,
  passkey: <LuFingerprint size={18} />,
  auth0: <LuAtSign size={18} />,
};

export const getIcon = (strategy?: string, name?: string): ReactNode => {
  if (strategy && ICON_MAP[strategy]) return ICON_MAP[strategy];
  if (name && ICON_MAP[name]) return ICON_MAP[name];
  return <DefaultConnectionIcon />;
};
